type CallBack<Params extends unknown[]> = (...args: Params) => void;
const callAll = <P extends unknown[]>(...fns: Array<CallBack<P> | undefined>) => (...args: P) => fns.forEach((fn) => fn && fn(...args));

export default callAll;
